import m, {Vnode, VnodeDOM} from "mithril";

export default class ImageDialog {
    private dialog?: HTMLDialogElement;
    private readonly isDialogSupported: boolean;
    private readonly self: ImageDialog;

    private translate: string = '0 0';
    private scale: string = '1';

    constructor(
        private readonly url: string,
    ) {
        this.isDialogSupported = typeof HTMLDialogElement === 'function';
        this.self = this;
    }

    public showModal(): void {
        this.self.dialog?.showModal();
    }
    public close(): void {
        this.zoomDisable();
        this.self.dialog?.close();
    }


    private isZoomed(): boolean {
        return this.scale !== '1';
    }

    private zoomEnable(): void {
        this.scale = '2';
        this.translate = '0 0'
    }

    private zoomDisable(): void {
        this.scale = '1';
        this.translate = '0 0';
    }


    private move(e: PointerEvent, target?: HTMLElement): void {
        target ??= <HTMLElement>e.currentTarget;
        const w = target.clientWidth;
        const h = target.clientHeight;
        const x = e.x - target.clientLeft;
        const y = e.y - target.clientTop;

        const tx = -x / w * 110 + 55;
        const ty = -y / h * 110 + 55;

        this.translate = `${tx}% ${ty}%`;
    }


    public view(): Vnode|null {
        if (!this.isDialogSupported) {
            return null;
        }

        return m('dialog.ImageDialog', {
            onclick: () => this.close(),
            oncreate: (vnode: VnodeDOM) => {
                this.self.dialog = <HTMLDialogElement>vnode.dom;
            }
        }, [
            m('.dialog-controls'+(this.isZoomed()?'.disabled':''), {}, [
                m('.control', { onclick: () => this.close(),}, [
                    m('i.icon.icon-close.text-light')
                ]),
            ]),
            m(".image-container"+(this.isZoomed()?'.zoomed':''), {
                onpointermove: (e: PointerEvent) => {
                    if (this.isZoomed()) {
                        this.move(e)
                    }
                },
                onclick: (e: PointerEvent) => {
                    e.stopPropagation();
                    if (this.isZoomed()) {
                        this.zoomDisable();
                    } else {
                        this.close();
                    }
                },
            }, [
                m("img", {
                    src: this.url,
                    draggable: false,
                    onclick: (e: PointerEvent) => {
                        if (this.isZoomed()) {
                            this.zoomDisable();
                        } else if (e.pointerType === "mouse" || (!e.pointerType && e instanceof MouseEvent /*Safari is shit*/)) {
                            this.zoomEnable()
                            this.move(e, (<HTMLElement>e.currentTarget).parentElement!);
                        }
                        e.stopPropagation();
                    },
                    style: {
                        scale: this.scale,
                        translate: this.translate,
                    }
                })
            ])
        ])
    }
}